/* ==========================================================================
   SearcherFli > Client > Calendar > Constants
   ========================================================================== */

const RANGE = 'range';
const SINGLE = 'single';

/* Exports */
module.exports = {
    RANGE,
    SINGLE
};
